/**
 * What the centre-screen banner says. It shows either a real elimination or
 * the shooter finding out they shot a decoy. Pure, so it is testable without
 * PIXI. EliminationNotification.js draws it.
 */
export const ELIMINATION_RED = 0xff5050;
export const BAMBOOZLED_PINK = 0xff4fd8;

/**
 * @param {{ kind?: 'elimination'|'decoy', victim?: string, victimName?: string }} notification
 * @returns {{ base: string, highlight: string, highlightColor: number }}
 */
export function bannerContent(notification) {
  if (notification?.kind === 'decoy') {
    return { base: 'You got ', highlight: 'bamboozled!', highlightColor: BAMBOOZLED_PINK };
  }
  return {
    base: 'Eliminated ',
    highlight: notification?.victimName || notification?.victim || 'Unknown',
    highlightColor: ELIMINATION_RED
  };
}
